import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-cancel-circle",
  "use": "foquz-icon-cancel-circle-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-cancel-circle\"><path d=\"M9.567 2.692L2.496 9.763M11 6A5 5 0 111 6a5 5 0 0110 0z\" stroke=\"#F96261\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol